import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intersection-observer';

import Vue from 'vue';
import App from './App.vue';
import Vuex from 'vuex';
import Notifications from 'vue-notification'

import router from './router';
import store from './store';

import { BootstrapVue } from 'bootstrap-vue';
import vSelect from 'vue-select';
import AxiosService from './services/axios.service';

import './lib/arrayEquals';
import './honeybadger';

// css
import 'vue-select/dist/vue-select.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';

import i18n from "./i18n";

library.add(fal);
library.add(far);
library.add(fas);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(BootstrapVue);
Vue.use(Vuex);
Vue.use(Notifications);
Vue.component('v-select', vSelect);

// Vue MQ (MediaQuery) https://github.com/AlexandreBonaventure/vue-mq
import VueMq from 'vue-mq'

Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
        sm: 576,
        md: 768,
        lg: 992,
        xl: Infinity,
    },
});

// Vue2Editor https://www.vue2editor.com/
import Vue2Editor from "vue2-editor";

Vue.use(Vue2Editor);

// Truncate Plugin
import truncate from 'vue-truncate-collapsed';
Vue.component('truncate', truncate);

AxiosService.init();

Vue.config.productionTip = true;
Vue.config.devtools = true;

export default new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app')
